import { AttachmentMinusIcon } from './AttachmentMinusIcon';

/**
 * author: Colton Wiscombe
 * id 2FE2F795-05F3-416B-8B74-ABC795E644EF
 * name attachment-minus
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/attachment-minus.svg
 * tags
 */
export const PaperclipSubtractIcon = AttachmentMinusIcon;
export default PaperclipSubtractIcon